import { Auth0Provider } from '@auth0/auth0-react';
import { lazy, PropsWithChildren, Suspense } from 'react';

type AuthenticationProviderProps = PropsWithChildren<unknown>;

const MockAuthenticationProvider = lazy(() => import('./MockAuthenticationProvider'));

const AuthenticationProvider = ({ children }: AuthenticationProviderProps) => {
  const isMockAuthEnabled = import.meta.env.VITE_MOCK_AUTH === 'true' && (import.meta.env.DEV || import.meta.env.MODE === 'e2e');

  if (isMockAuthEnabled) {
    return (
      <Suspense fallback={null}>
        <MockAuthenticationProvider>{children}</MockAuthenticationProvider>
      </Suspense>
    );
  }

  return (
    <Auth0Provider
      domain={`${import.meta.env.VITE_REACT_APP_AUTH_DOMAIN}`}
      clientId={`${import.meta.env.VITE_REACT_APP_AUTH_CLIENT_ID}`}
      useRefreshTokens
      authorizationParams={{
        audience: `${import.meta.env.VITE_REACT_APP_AUTH_AUDIENCE}`,
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthenticationProvider;
